import React from 'react';
import { SectionHeading } from './SectionHeading';
import { assets } from '../data/assets';
import { books } from '../data/content';
import { resizedImage, resizedSrcSet } from '../utils/image';
export function WhatsIncluded() {
  return <section className="bg-ivory py-12 md:py-20 px-4" data-id="element-255" data-mp="3ub72vucokg6v">
      <div className="max-w-5xl mx-auto" data-id="element-256" data-mp="25bmrnydcah9">
        <SectionHeading eyebrow="Tu Biblioteca Pausa Propia" title="Tres libros para acompañarte desde la pausa hasta la transformación." subtitle="Empieza por lo que necesitas hoy o recorre la biblioteca a tu ritmo." data-id="element-257" data-mp="26d05z2ux925" />

        <div className="grid grid-cols-1 md:grid-cols-[5fr_7fr] gap-6 md:gap-10 items-start" data-id="element-258" data-mp="gv95hodj47z2">
          <figure className="md:sticky md:top-6" data-id="element-259" data-mp="ltavkt9dh7k1">
            <img src={resizedImage(assets.libraryMockup, 480)} srcSet={resizedSrcSet(assets.libraryMockup, [340, 480, 600, 720, 900])} sizes="(min-width: 768px) 400px, 330px" alt="Los tres libros de la Biblioteca de Arteterapia Pausa Propia" className="w-full max-w-[330px] md:max-w-none mx-auto rounded-2xl shadow-soft object-contain" loading="lazy" decoding="async" width={1080} height={1080} data-id="element-260" data-mp="lrzjm65rwthu" />
          </figure>

          <ol className="space-y-3 md:space-y-4" data-id="element-261" data-mp="21gijjf9a8gmi">
            {books.map(book => <li key={book.label} className="bg-white rounded-2xl border border-sand-deep p-5 md:p-6" data-id="element-262" data-mp="2fg1f78kwpzhx">
                <div className="flex items-baseline justify-between gap-3" data-id="element-263" data-mp="2ahzxos34q88k">
                  <p className="font-sans text-[11px] font-bold uppercase tracking-wider text-terracotta" data-id="element-264" data-mp="2p6cu1q64pt3l">
                    {book.label}
                  </p>
                  <span className="flex-shrink-0 font-sans text-xs text-forest/60" data-id="element-265" data-mp="2k7rttqqvn9f5">75 páginas</span>
                </div>
                <h3 className="mt-1 font-serif text-lg md:text-xl font-bold text-forest" data-id="element-266" data-mp="2y4y6r4ox6dwg">
                  {book.title}
                </h3>
                <p className="mt-1 font-sans text-[14.5px] md:text-[15px] text-forest/75 leading-[1.5]" data-id="element-267" data-mp="319f7hoo0cqfd">
                  {book.description}
                </p>
                <ul className="mt-3 flex flex-wrap gap-1.5" aria-label="Incluye" data-id="element-268" data-mp="365e05ogdcull">
                  {book.includes.map(item => <li key={item} className="rounded-full bg-sand px-2.5 py-1 font-sans text-[12.5px] font-medium text-forest/80" data-id="element-269" data-mp="3fxs5er6nojci">
                      {item}
                    </li>)}
                </ul>
              </li>)}

            <li className="rounded-2xl bg-lavender-light px-5 py-5 md:px-6" data-id="element-270" data-mp="3tymelc1j2oc8">
              <p className="font-serif text-lg font-bold text-forest" data-id="element-271" data-mp="2r9zd2k7gkyy">No es solo journaling.</p>
              <p className="mt-1 font-sans text-[14.5px] md:text-[15px] text-forest/75 leading-[1.5]" data-id="element-272" data-mp="1zk1zdevz7l08">
                Aquí también pintas, coloreas, recortas, mezclas y creas.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </section>;
}